import { saveAs } from 'file-saver';

/* eslint-disable */
export enum FileInputType {
  JSONString = 0,
  Base64,
}

export enum FileOutputType {
  JSON = 0,
  ZIP,
}

const downloadFile = {
  inBrowser(
    inputType: FileInputType,
    outputType: FileOutputType,
    input: any,
    outputName: string,
  ) {
    let blobPart: BlobPart[] | undefined;
    let type: string = '';

    if (inputType === FileInputType.JSONString) {
      blobPart = [JSON.stringify(input, null, 4)];
    } else if (inputType === FileInputType.Base64) {
      blobPart = this.b64toBlobPart(input);
    }
    if (outputType === FileOutputType.JSON) {
      type = 'json;charset=utf-8';
    } else if (outputType === FileOutputType.ZIP) {
      type = 'application/zip';
    }
    const blob = new Blob(blobPart, { type });
    saveAs(blob, outputName);
  },
  b64toBlobPart(b64Data: string, sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return byteArrays;
  },
};

export default downloadFile;
